export const SecurityServiceList = [
  {
    id: 1,
    name: 'VERISOUL',
    label: 'Verisoul',
  },
  {
    id: 2,
    name: 'REPDATA',
    label: 'RepData',
  },
  {
    id: 3,
    name: 'DEVICE_INTELLIGENCE_SERVICE',
    label: 'Device Intelligence Service',
  },
];
